import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../pages/home/index.vue';
import Detail from '../pages/detail/detail.vue';
import Details from '../pages/details/details.vue';
// import Contact from '../pages/contact/index.vue';
// import Gqxx from '../pages/gqxx/index.vue';
// import Gqxxinfo from '../pages/gqxxinfo/index.vue';
// import Hwgq from '../pages/hwgq/index.vue';
// import Hwgqinfo from '../pages/hwgqinfo/index.vue';
// import Fp from '../pages/fp/index.vue';
// import Fpinfo from '../pages/fpinfo/index.vue';
Vue.use(VueRouter);
const routes = [
	// 在这里定义你的路由
	{
		path: '/',
		component: Home,
	}, {
		path: '/detail',
		component: Detail,
	}, {
		path: '/details',
		component: Details,
	},
];
const router = new VueRouter({
	routes
});
export default router;